var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex"}},[_c('cloud-sidebar',{attrs:{"open":_vm.open},on:{"change":_vm.change}}),_c('router-view',{attrs:{"className":_vm.className}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }